import { useEffect, useRef, useState } from "react";

export function useInView(options?: IntersectionObserverInit & { initialInView?: boolean }) {
  const { initialInView = false, ...observerOptions } = options ?? {};
  const [isInView, setIsInView] = useState(initialInView);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      {
        threshold: 0.1,
        ...observerOptions,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [options]);

  return { ref, isInView };
}

